// Querys and Mutations
import {
  ALL_ACTIVE,
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE
} from '@/graphql/config/BondTypeGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { BondType, BondTypeForm, BondTypesWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class BondTypesService {
    /**
    * Queries
    */
    async getActivated (name = '', code = '', is_massive: boolean|null = null): Promise<BondType[]> {
      const result = await apolloClient.query({
          query: ALL_ACTIVE,
          variables: {
            name,
            code,
            is_massive
          }
      })
      return result.data.bondTypesActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<BondTypesWithPagination> {
      const result = await apolloClient.query({
        query: GET_WITH_PAGINATION,
        variables: {
          page: page,
          perPage: perPage
        }
      })
      const pagination: Paginator = result.data.bondTypesWithPagination.paginatorInfo
      const data: BondType[] = result.data.bondTypesWithPagination.data
      const response: BondTypesWithPagination = {
        objects: data,
        pagination: pagination
      }
      return response
    }

    /**
     * Mutations
     */
    async create (form: BondTypeForm): Promise<BondType> {
      const result = await apolloClient.mutate({
        mutation: CREATE,
        variables: {
          input: form
        }
      })
      return result.data.createBondType
    }

    async update (id: number, form: BondTypeForm): Promise<BondType> {
      const result = await apolloClient.mutate({
        mutation: UPDATE,
        variables: {
          id: id,
          input: form
        }
      })
      return result.data.updateBondType
    }

    async delete (id: number): Promise<ResponseDefault> {
      await apolloClient.mutate({
        mutation: DELETE,
        variables: {
          id: id
        }
      })
      return {
        success: true,
        errors: []
      }
    }
}

export default new BondTypesService()
